import { Content } from "_metronic/layout/components/Content"
import { Toolbar } from "_metronic/layout/components/toolbar/Toolbar"
import { PageLink, PageTitle } from "_metronic/layout/core"
import * as authHelper  from '@modules/auth/core/AuthHelpers'
import { FC, ReactNode } from "react"

type PageLayoutProps = {
  path: string,
  title: string,
  children?: ReactNode,
  className?: string
}

function getBreadcrumb(path: any): Array<PageLink> {
  const menuItems =  authHelper.getMenu()
  function findPath(item: any, path: any): Array<PageLink> | null {
    if (item.path === path) return [{
      title: item.text,
      path: "",
      isSeparator: true,
      isActive: true,
    }];
    if (item.items) {
      for (const subItem of item.items) {
        const result = findPath(subItem, path);
        if (result) return [{
          title: item.text,
          path: "",
          isSeparator: true,
          isActive: true,
        }, ...result];
      }
    }
    return null;
  }

  for (const item of menuItems) {
    const result = findPath(item, path);
    if (result) return result;
  }
  return [];
}

const PageLayout: FC<PageLayoutProps> = ({ title, path, children, className='card card-custom p-10 pt-10' }) => {
  /*const breadcrumbs = getBreadcrumb("/" + path);*/
  return (
    <>
    {/* <PageTitle breadcrumbs={breadcrumbs}>{title}</PageTitle> */}
      <PageTitle>{title}</PageTitle>
      <Toolbar />
      <Content>
        <div className={className} id="content-layout">{children}</div>
      </Content>

    </>
  )
}

export { PageLayout }

